import {useAppSelector} from "../../app/store/hooks.ts";

export const useIsReadyToGenerate = () => {
    const hasMissingRequired = useAppSelector((state) =>
        state.generation.prompts.some((input) => input.isRequired && !input.value)
    );

    return !hasMissingRequired;
}
